import { useEffect, useState } from 'react';
import type { ConfigPublica } from '../../../compartido/api';
import { api } from './api';

/**
 * La configuración pública se pide una vez por visita y se comparte. Si
 * falla, el siguiente componente que la pida vuelve a intentar.
 */
let promesa: Promise<ConfigPublica> | undefined;

export function cargarConfig(): Promise<ConfigPublica> {
  promesa ??= api.config().catch((e) => {
    promesa = undefined;
    throw e;
  });
  return promesa;
}

export function useConfig(): { config?: ConfigPublica; error?: unknown } {
  const [estado, setEstado] = useState<{ config?: ConfigPublica; error?: unknown }>({});
  useEffect(() => {
    let vivo = true;
    cargarConfig().then(
      (config) => vivo && setEstado({ config }),
      (error) => vivo && setEstado({ error }),
    );
    return () => {
      vivo = false;
    };
  }, []);
  return estado;
}

/** Correo al que escribir si hay un imprevisto. Sin él, la opción no se muestra. */
export const CORREO_CONTACTO: string | undefined = import.meta.env['VITE_CORREO_CONTACTO'] || undefined;
